import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AccountHealthScore, ActiveUsers, GeneralDetailSection, LicenseList, PinnedFeatureUsage, TopCustomObject,
} from '../../modules/Accounts';
import { ACCOUNT_CARDS_ID, ACCOUNT_PERSONA } from '../../utils/constants';
import { TopFeatures } from '../TopFeatures';

const useAccountDetail = (props = {}) => {
  const {
    selectedPersona,
    refreshUsers,
    setRefreshUsers,
    permissions,
    isShareableScreens,
    tenantId,
    accountId,
    accountName,
    accountOrgId,
  } = props;

  const [customObjectPinningData, setCustomObjectPinningData] = useState({
    data: [],
    error: '',
    loading: true,
  });

  const [customObject, setCustomObject] = useState({
    data: [],
    error: '',
    loading: true,
  });

  const [generalDetail, setGeneralDetail] = useState({
    data: {},
    error: '',
    loading: true,
  });

  const [sortModel, setSortModel] = useState([
    {
      field: 'UniqueUserCount',
      sort: 'asc',
    },
  ]);
  const [visibility, setVisibility] = useState(true);

  const pinningData = useSelector((state) => state.customObjectPinningData);

  const setCustomObjectPinning = () => {
    const { response, loading, error } = pinningData;
    setCustomObjectPinningData({
      ...customObjectPinningData, data: response || [], loading, error,
    });
  };

  const customObjectsData = useSelector((state) => state.customObjects);

  const setCustomObjects = () => {
    const { response, loading, error } = customObjectsData;
    setCustomObject({
      ...customObject, data: response?.responseArray ?? [], loading, error,
    });
  };

  const generalDetailsData = useSelector((state) => state.generalDetails);

  const setGeneralDetails = () => {
    const { response, loading, error } = generalDetailsData;
    setGeneralDetail({
      ...generalDetail, data: response?.responseData, loading, error,
    });
    setVisibility(response?.responseData?.visibility !== false);
  };

  useEffect(() => {
    setCustomObjects();
  }, [customObjectsData]);

  useEffect(() => {
    setGeneralDetails();
  }, [generalDetailsData]);

  useEffect(() => {
    setCustomObjectPinning();
  }, [pinningData]);

  const visibleBoxIds = ACCOUNT_PERSONA[selectedPersona] || [];
  const isShareQuery = { isShare: isShareableScreens, accountOrgId, tenantId };

  const boxComponents = {
    [ACCOUNT_CARDS_ID.GENERAL]: <GeneralDetailSection permissions={permissions} generalDetail={generalDetail} isShare={isShareableScreens} />,
    [ACCOUNT_CARDS_ID.LICENSE_LIST]: <LicenseList />,
    [ACCOUNT_CARDS_ID.KPI_SCORES]: <AccountHealthScore isShare={isShareableScreens} tenantId={tenantId} accountOrgId={accountOrgId} accountId={accountId} permissions={permissions} />,
    [ACCOUNT_CARDS_ID.ACTIVE_USERS]: <ActiveUsers page="account" subHeading more={!isShareableScreens} accountName={accountName} accountId={accountId} refreshUsers={refreshUsers} setRefreshUsers={setRefreshUsers} isShareQuery={isShareQuery} />,
    [ACCOUNT_CARDS_ID.TOP_FEATURES]: <TopFeatures accountId={accountId} accountName={accountName} isShare={isShareableScreens} tenantId={tenantId} accountOrgId={accountOrgId} />,
    [ACCOUNT_CARDS_ID.PINNED_FEATURES]: <PinnedFeatureUsage accountId={accountId} accountName={accountName} isShare={isShareableScreens} tenantId={tenantId} accountOrgId={accountOrgId} />,
    [ACCOUNT_CARDS_ID.TOP_CUSTOM_OBJ]: <TopCustomObject moreButton={!isShareableScreens} customObject={customObject} customObjectPinningData={customObjectPinningData} pageSize={5} accountId={accountId} accountName={accountName} isShare={isShareableScreens} permissions={permissions} />,
  };

  return {
    sortModel, setSortModel, generalDetail, visibility, setVisibility, visibleBoxIds, boxComponents, customObject, customObjectPinningData,
  };
};

export default useAccountDetail;
